module.exports = __webpack_public_path__ + "img/nginx.541e3f31.webp";